import { render, staticRenderFns } from "./TheEvidenceAdd.vue?vue&type=template&id=ea450c84&scoped=true&"
import script from "./TheEvidenceAdd.vue?vue&type=script&lang=js&"
export * from "./TheEvidenceAdd.vue?vue&type=script&lang=js&"
import style0 from "./TheEvidenceAdd.vue?vue&type=style&index=0&id=ea450c84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea450c84",
  null
  
)

export default component.exports